import { InsightsTimeframes } from '@griply/types';
import React from 'react';
import { InsightsTimeframeSelection } from 'shared/components/ui/insights-timeframe-selection';

export type MetaStatisticsTimeframeProps = {
  timeframe: InsightsTimeframes;
  onChange: (timeframe: InsightsTimeframes) => void;
};

export const MetaStatisticsTimeframe: React.FC<
  MetaStatisticsTimeframeProps
> = ({ timeframe, onChange }) => (
  <InsightsTimeframeSelection
    value={timeframe}
    onChange={onChange}
    hasDarkBackground
  />
);
